import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HlmInput } from '@spartan-ng/helm/input';
import { HlmLabel } from '@spartan-ng/helm/label';

import { DetailGeneralFormGroup } from '../jalon-detail-form-groups.types';
import { HlmFieldImports } from '@spartan-ng/helm/field';

@Component({
  selector: 'app-detail-general',
  imports: [ReactiveFormsModule, HlmInput, HlmLabel, HlmFieldImports],
  templateUrl: './detail-general.component.html',
})
export class DetailGeneralComponent {
  readonly form = input.required<DetailGeneralFormGroup>();
}
